import { createFileRoute } from "@tanstack/react-router";
import { PhoneCampaignList } from "@/components/phone-banking/PhoneCampaignList";

export const Route = createFileRoute("/_app/_/phone-banking/")({
	component: PhoneBankingIndexPage,
});

function PhoneBankingIndexPage() {
	return (
		<div className="p-6">
			<PhoneCampaignList />
		</div>
	)
}
